import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import SeoHelmet from "@/components/SeoHelmet";
import seoConfig from "@/data/seo.config";
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
import ReCAPTCHA from "react-google-recaptcha";
import "react-phone-number-input/style.css";
import axios from "axios";
import { showSuccessMessage } from "@/utils/common";
import { ToastContainer } from 'react-toastify';
import errorMessages from "@/constant/errorMessages";
import API_URL from "@/constant/api.config";
import defaultValues from "@/constant/defaultValues";
import Button from "@/components/Button";
import ConsentManager from "@/modules/frontend/components/ConsentManager";
import { motion } from "framer-motion";
import WhatsappChat from "@/components/WhatsappChat";

const Index = () => {

  const [phoneValue, setphoneValue] = useState();
  const [mobileValue, setmobileValue] = useState();
  const [isButtonDisabled, setisButtonDisabled] = useState(false);
  const [errors, setErrors] = useState({});
  const [recaptchaValue, setRecapchaValue] = useState(null);
  const recaptcha = useRef();
  // const [successmsg, setMessage] = useState("");
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    mobile: "",
    message: "",
    company_name: "",
  });
  const { EMAIL_FIELD_MAX_LENGTH, IGNORE_EMAILS } = defaultValues;

  const fadeUpVariant = {
    hidden: { opacity: 0, y: 20 },
    visible: (delay = 0) => ({
      opacity: 1,
      y: 0,
      transition: { duration: 0.8, delay },
    }),
  };

  const handleChange = (e) => {
    setFormData((prevalue) => {
      return {
        ...prevalue,
        [e.target.name]: e.target.value,
      };
    });
  };

  const handleRecaptchaChange = (value) => {
    setRecapchaValue(value);
    setErrors((prevErrors) => ({
      ...prevErrors,
      recaptcha: value ? "" : "Please complete the CAPTCHA",
    }));
  };

  const handlePhoneChange = (val) => {
    setphoneValue(val);
    setFormData((prevalue) => {
      return {
        ...prevalue,
        phone: val,
      };
    });
  };

  const handleMobileChange = (val) => {
    setmobileValue(val);
    setFormData((prevalue) => {
      return {
        ...prevalue,
        mobile: val,
      };
    });
  };

  const handleFocusOut = async (e) => {
    let flag = 0;
    let er = { ...errors };

    if (e.target.name === "first_name") {
      if (e.target.value === "") {
        flag = 1;
        er.first_name = errorMessages.FIELD_REQUIRED;
      } else if (e.target.value.length > 40) {
        flag = 1;
        er.first_name = errorMessages.MAX_LENGTH_EXCEEDED;
      } else {
        const regExp =
          /^(?!\d+$)[a-zA-Z\s\-\'.\(\)&]*\s*(\([a-zA-Z\s\-\'.\&]*\))?[\s\-\.\(\)&a-zA-Z]*\d?[\s\-\.\(\)&a-zA-Z0-9]*$/;
        const check = regExp.test(e.target.value);
        if (check === false) {
          flag = 1;
          er.first_name = errorMessages.IN_VALID_FIELD_FORMAT;
        } else {
          flag = 0;
          er.first_name = "";
        }
      }
    }

    if (e.target.name === "last_name") {
      flag = 0;
      if (e.target.value !== "") {
        if (e.target.value.length > 40) {
          flag = 1;
          er.last_name = errorMessages.MAX_LENGTH_EXCEEDED;
        } else {
          const regExp =
            /^(?!\d+$)[a-zA-Z\s\-\'.\(\)&]*\s*(\([a-zA-Z\s\-\'.\&]*\))?[\s\-\.\(\)&a-zA-Z]*\d?[\s\-\.\(\)&a-zA-Z0-9]*$/;
          const check = regExp.test(e.target.value);
          if (check === false) {
            flag = 1;
            er.last_name = errorMessages.IN_VALID_FIELD_FORMAT;
          } else {
            flag = 0;
            er.last_name = "";
          }
        }
      } else {
        flag = 0;
        er.last_name = "";
      }
    }

    if (e.target.name === "email") {
      if (e.target.value === "") {
        flag = 1;
        er.email = errorMessages.FIELD_REQUIRED;
      } else if (e.target.value.length > EMAIL_FIELD_MAX_LENGTH) {
        flag = 1;
        er.email = errorMessages.MAX_LENGTH_150_EXCEEDED;
      } else {
        const currentEmail = e.target.value.split("@")[1];
        const regExp = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        const check = regExp.test(e.target.value);
        if (check === false) {
          flag = 1;
          er.email = errorMessages.IN_VALID_FIELD_FORMAT;
        } else if (IGNORE_EMAILS.includes(currentEmail)) {
          flag = 1;
          er.email = errorMessages.IN_VALID_FIELD_FORMAT;
        } else {
          flag = 0;
          er.email = "";
        }
      }
    }
    if (e.target.name === "phone") {
      let phoneValue = e.target.value.trim();
      if (!phoneValue) {
        flag = 1;
        er.phone = errorMessages.FIELD_REQUIRED;
      } else {
        let numberWithoutCountryCode = phoneValue
          .replace(/^\+(\d{1,4})\s?/, "")
          .replace(/\s/g, "");

        if (numberWithoutCountryCode.length === 0) {
          flag = 1;
          er.phone = errorMessages.FIELD_REQUIRED;
        } else if (!isValidPhoneNumber(phoneValue)) {
          flag = 1;
          er.phone = errorMessages.CONTACT_NUMBER_VALIDATION_MSG;
        } else {
          flag = 0;
          er.phone = "";
        }
      }
    }

    if (e.target.name === "mobile") {
      let mobileValue = e.target.value;
      let numberWithoutCountryCode = mobileValue.replace(/^\+(\d{1,4})\s?/, "");
      numberWithoutCountryCode = numberWithoutCountryCode.replace(/\s/g, "");

      if (numberWithoutCountryCode.length === 0) {
        flag = 1;
        er.mobile = "";
      } else if (
        !isValidPhoneNumber(mobileValue) &&
        numberWithoutCountryCode.length > 0
      ) {
        flag = 1;
        er.mobile = errorMessages.CONTACT_NUMBER_VALIDATION_MSG;
      } else {
        flag = 0;
        er.mobile = "";
      }
    }
    if (e.target.name === "message") {
      if (e.target.value === "") {
        flag = 1;
        er.message = errorMessages.FIELD_REQUIRED;
      } else {
        flag = 0;
        er.message = "";
      }
    }

    setErrors(er);
    if (flag === 0) {
      setisButtonDisabled(false);
      return false;
    } else {
      // setisButtonDisabled(true);
      return true;
    }
  };

  const validation = () => {
    let er = { ...errors };
    let flag = 0;

    if (formData.first_name === "") {
      flag = 1;
      er.first_name = errorMessages.FIELD_REQUIRED;
    } else if (formData.first_name.length > 40) {
      flag = 1;
      er.first_name = errorMessages.MAX_LENGTH_EXCEEDED;
    } else {
      const regExp =
        /^(?!\d+$)[a-zA-Z\s\-\'.\(\)&]*\s*(\([a-zA-Z\s\-\'.\&]*\))?[\s\-\.\(\)&a-zA-Z]*\d?[\s\-\.\(\)&a-zA-Z0-9]*$/;
      const check = regExp.test(formData.first_name);
      if (check === false) {
        flag = 1;
        er.first_name = errorMessages.IN_VALID_FIELD_FORMAT;
      } else {
        flag = 0;
        er.first_name = "";
      }
    }

    if (formData.last_name !== "") {
      if (formData.last_name.length > 40) {
        flag = 1;
        er.last_name = errorMessages.MAX_LENGTH_EXCEEDED;
      } else {
        const regExp =
          /^(?!\d+$)[a-zA-Z\s\-\'.\(\)&]*\s*(\([a-zA-Z\s\-\'.\&]*\))?[\s\-\.\(\)&a-zA-Z]*\d?[\s\-\.\(\)&a-zA-Z0-9]*$/;
        const check = regExp.test(formData.last_name);
        if (check === false) {
          flag = 1;
          er.last_name = errorMessages.IN_VALID_FIELD_FORMAT;
        } else {
          flag = 0;
          er.last_name = "";
        }
      }
    } else {
      flag = 0;
      er.last_name = "";
    }

    if (formData.email === "") {
      flag = 1;
      er.email = errorMessages.FIELD_REQUIRED;
    } else if (formData.email.length > EMAIL_FIELD_MAX_LENGTH) {
      flag = 1;
      er.email = errorMessages.MAX_LENGTH_150_EXCEEDED;
    } else {
      const currentEmail = formData.email.split("@")[1];
      const regExp = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      const check = regExp.test(formData.email);
      if (check === false) {
        flag = 1;
        er.email = errorMessages.IN_VALID_FIELD_FORMAT;
      } else if (IGNORE_EMAILS.includes(currentEmail)) {
        flag = 1;
        er.email = errorMessages.IN_VALID_FIELD_FORMAT;
      } else {
        flag = 0;
        er.email = "";
      }
    }

    if (
      phoneValue === undefined ||
      !phoneValue ||
      !isValidPhoneNumber(phoneValue)
    ) {
      if (phoneValue == null) {
        flag = 1;
        er.phone = errorMessages.FIELD_REQUIRED;
      } else {
        let numberWithoutCountryCode = phoneValue.replace(
          /^\+(\d{1,4})\s?/,
          ""
        );
        numberWithoutCountryCode = numberWithoutCountryCode.replace(/\s/g, "");
        if (
          phoneValue === undefined ||
          (phoneValue === "" && numberWithoutCountryCode.length == 0)
        ) {
          flag = 1;
          er.phone = errorMessages.FIELD_REQUIRED;
        } else {
          if (numberWithoutCountryCode.length > 0) {
            flag = 1;
            er.phone = errorMessages.CONTACT_NUMBER_VALIDATION_MSG;
          }
        }
      }
    } else {
      flag = 0;
      er.phone = "";
    }

    if (mobileValue) {
      let numberWithoutCountryCode = mobileValue.replace(/^\+(\d{1,4})\s?/, "");
      numberWithoutCountryCode = numberWithoutCountryCode.replace(/\s/g, "");
      if (
        !mobileValue ||
        (!isValidPhoneNumber(mobileValue) &&
          numberWithoutCountryCode.length > 0)
      ) {
        flag = 1;
        er.mobile = errorMessages.MOBILE_NUMBER_VALIDATION_MSG;
      }
    }

    if (mobileValue && phoneValue) {
      if (mobileValue === phoneValue) {
        flag = 1;
        er.mobile = errorMessages.UNIQUE_MSG;
      }
      if (mobileValue !== phoneValue && isValidPhoneNumber(mobileValue)) {
        flag = 0;
        er.mobile = "";
      }
    }

    if (formData.message === "") {
      flag = 1;
      er.message = errorMessages.FIELD_REQUIRED;
    } else {
      flag = 0;
      er.message = "";
    }

    if (recaptchaValue === null) {
      flag = 1;
      er.recaptcha = "Please verify the reCAPTCHA!";
    } else {
      flag = 0;
      er.recaptcha = "";
    }

    setErrors(er);
    if (flag === 1) {
      return false;
    } else {
      return true;
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validation()) {
      try {
        setisButtonDisabled(true);
        axios
          .post(API_URL + "/contact-inquiry", formData, {
            headers: {
              Accept: "application/json",
            },
            timeout: 10000,
          })
          .then((response) => {
            if (response.data.status === true) {
              // setMessage(
              //   "The contact inquiry has been submitted successfully."
              // );
              showSuccessMessage(
                "The contact inquiry has been submitted successfully."
              );
              setTimeout(() => {
                recaptcha.current.reset();
                // setMessage("");
                const frmdata = {
                  first_name: "",
                  last_name: "",
                  email: "",
                  phone: "",
                  mobile: "",
                  message: "",
                  company_name: "",
                };
                setFormData(frmdata);
                setmobileValue(null);
                setphoneValue(null);
                setErrors([]);
                setisButtonDisabled(false);
              }, 3000);
              setRecapchaValue(null);
            } else {
              setisButtonDisabled(false);
              setErrors([]);
              const errors = {};
              if (response.data.error.first_name) {
                errors.first_name = response.data.error.first_name;
              }
              if (response.data.error.last_name) {
                errors.last_name = response.data.error.last_name;
              }
              if (response.data.error.email) {
                errors.email = response.data.error.email;
              }
              if (response.data.error.phone) {
                errors.phone = response.data.error.phone;
              }
              if (response.data.error.message) {
                errors.message = response.data.error.message;
              }
              setErrors(errors);
              return Object.keys(errors).length > 0;
            }
          })
          .catch((error) => {
            setisButtonDisabled(false);
            setRecapchaValue(null);
            console.error("Error fetching data:", error);
          });
      } catch (err) {
        console.error(err);
      }
    }
  };

  useEffect(() => {
    if (recaptchaValue !== null) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        recaptcha: "",
      }));
      setisButtonDisabled(false);
    }
  }, [recaptchaValue]);

  const styleError = {
    display: "block",
  };

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, []);

  return (
    <>
      <section className="inner-pad page contact-us-wrape">
        <SeoHelmet
          title={seoConfig.contactUs.title}
          description={seoConfig.contactUs.description}
          keywords={seoConfig.contactUs.keywords}
          author={seoConfig.contactUs.author}
        />
        {/* inner banner wrape START  */}
        <div className="inner-banner contact-us">
          <div className="container">
            <div className="content-wrape desk-hide">
              <motion.h2
                className="animate-child"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.2 }}
                custom={0.2}
                variants={fadeUpVariant}
              >
                <span className="light">
                  Contact
                </span>&nbsp;
                <span className="blue">
                  Us
                </span>
              </motion.h2>
              <motion.p
                className="animate-child"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.2 }}
                custom={0.2}
                variants={fadeUpVariant}
              >Want to get in touch? We'd love to hear from you. Here's how you can reach us.</motion.p>
            </div>
          </div>
        </div>
        {/* inner banner wrape END  */}
        {/* <section className="inner-banner-wrape global-advertising banner-wrape">
          <div className="inner"> Contact Us</div>
          <span class="sprite decoration"></span>
        </section> */}

        <div className="container map-bg">
          <div className=" inner-page-content-wrape">
            <div className="content-wrape mobile-show page-head ">
              <motion.h2 className="mobile-head-text animate-child"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.2 }}
                custom={0.2}
                variants={fadeUpVariant}
              >
                <span className="light">Contact</span>&nbsp;
                <span className="blue-text"> Us</span>
              </motion.h2>
              <motion.p className="animate-child"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.2 }}
                custom={0.2}
                variants={fadeUpVariant}
              >Want to get in touch? We'd love to hear from you. Here's how you can reach us.</motion.p>
            </div>
          </div>
          <div className="row">
            <div className="col-xxl-12">
              <div className="white-wrape">
                <div className="row">
                  <div className="col-xxl-7 col-xl-7 col-lg-7 col-md-12 col-sm-12">
                    <div className="section-head desk-hide">
                      <div className="head-text">
                        <h2 className="head">
                          <span className="light">
                            Contact&nbsp;
                          </span>
                          <span className="blue">
                            Us
                          </span>
                        </h2>
                      </div>

                      <p className="text">
                        Want to get in touch? We'd love to hear from you. Here's how you can reach us.
                      </p>
                    </div>

                    <div className="form-wrape">
                      <div className="form-pad">
                        <form onSubmit={handleSubmit}>
                          <div className="row">
                            <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12">
                              <div className={`input-wrape ${errors.first_name ? 'error-show' : ''}`}>
                                <div className="input-pad">
                                  <input
                                    type="text"
                                    name="first_name"
                                    className="input"
                                    value={formData.first_name}
                                    autoComplete="off"
                                    placeholder="Enter first name *"
                                    onChange={handleChange}
                                    onBlur={handleFocusOut}
                                  />
                                  {errors.first_name && (
                                    <span
                                      className="invalid-feedback"
                                      style={styleError}
                                    >
                                      {errors.first_name}
                                    </span>
                                  )}
                                </div>
                              </div>

                            </div>
                            <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12">
                              <div className={`input-wrape ${errors.last_name ? 'error-show' : ''}`}>
                                <div className="input-pad">
                                  <input
                                    type="text"
                                    name="last_name"
                                    value={formData.last_name}
                                    className="input"
                                    autoComplete="off"
                                    placeholder="Enter last name"
                                    onChange={handleChange}
                                    onBlur={handleFocusOut}
                                  />
                                  {errors.last_name && (
                                    <span
                                      className="invalid-feedback"
                                      style={styleError}
                                    >
                                      {errors.last_name}
                                    </span>
                                  )}
                                </div>
                              </div>
                            </div>
                            <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12">
                              <div className={`input-wrape ${errors.email ? 'error-show' : ''}`}>
                                <div className="input-pad">
                                  <input
                                    type="text"
                                    name="email"
                                    className="input"
                                    value={formData.email}
                                    autoComplete="off"
                                    placeholder="Enter your email *"
                                    onChange={handleChange}
                                    onBlur={handleFocusOut}
                                  />
                                  {errors.email && (
                                    <span
                                      className="invalid-feedback"
                                      style={styleError}
                                    >
                                      {errors.email}
                                    </span>
                                  )}
                                </div>
                              </div>
                            </div>
                            <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12">
                              <div className={`input-wrape ${errors.phone ? 'error-show' : ''}`}>
                                <div className="input-pad">
                                  <PhoneInput
                                    id="contact-form-phone"
                                    className="input"
                                    name="phone"
                                    international
                                    limitMaxLength
                                    placeholder="Enter phone number *"
                                    autoComplete="off"
                                    value={phoneValue}
                                    onChange={handlePhoneChange}
                                    onBlur={handleFocusOut}
                                  />
                                  {errors.phone && (
                                    <span
                                      className="invalid-feedback"
                                      style={styleError}
                                    >
                                      {errors.phone}
                                    </span>
                                  )}
                                </div>
                              </div>
                            </div>
                            <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12">
                              <div className={`input-wrape ${errors.mobile ? 'error-show' : ''}`}>
                                <div className="input-pad">
                                  <PhoneInput
                                    id="contact-form-phone"
                                    className="input"
                                    name="mobile"
                                    international
                                    limitMaxLength
                                    placeholder="Enter whatsapp number"
                                    autoComplete="off"
                                    value={mobileValue}
                                    onChange={handleMobileChange}
                                    onBlur={handleFocusOut}
                                  />
                                  {errors.mobile && (
                                    <span
                                      className="invalid-feedback"
                                      style={styleError}
                                    >
                                      {errors.mobile}
                                    </span>
                                  )}
                                </div>
                              </div>
                            </div>
                            <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12">
                              <div className={`input-wrape ${errors.company_name ? 'error-show' : ''}`}>
                                <div className="input-pad">
                                  <input
                                    type="text"
                                    name="company_name"
                                    value={formData.company_name}
                                    className="input"
                                    autoComplete="off"
                                    placeholder="Enter company name"
                                    onChange={handleChange}
                                  //onBlur={handleFocusOut}
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="col-xxl-12">
                              <div className={`input-wrape ${errors.message ? 'error-show' : ''}`}>
                                <div className="input-pad">
                                  <textarea
                                    id="contact-form-message"
                                    className="input"
                                    rows="3"
                                    placeholder="Write a message *"
                                    name="message"
                                    value={formData.message}
                                    onChange={handleChange}
                                    onBlur={handleFocusOut}
                                  ></textarea>
                                  {errors.message && (
                                    <span
                                      className="invalid-feedback"
                                      style={styleError}
                                    >
                                      {errors.message}
                                    </span>
                                  )}
                                </div>
                              </div>
                            </div>
                            <div className="col-xxl-8 col-xl-8 col-lg-8 col-md-8 col-sm-12 captcha-wrape-pad">
                              <div className="captcha-wrapes">
                                <ReCAPTCHA
                                  sitekey={process.env.REACT_APP_SITE_KEY}
                                  onChange={handleRecaptchaChange}
                                  ref={recaptcha}
                                  onExpired={() => {
                                    setRecapchaValue(null);
                                    setErrors((prevErrors) => ({
                                      ...prevErrors,
                                      recaptcha: "Please complete the CAPTCHA",
                                    }));
                                  }}
                                  onBlur={handleFocusOut}
                                />
                                {errors.recaptcha && (
                                  <div
                                    className="invalid-feedback"
                                    style={styleError}
                                  >
                                    {errors.recaptcha}
                                  </div>
                                )}
                              </div>

                            </div>
                            <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-12 inquiry-form-btn">
                              <Button
                                className="btn secondry-btn"
                                type="submit"
                                disabled={isButtonDisabled}
                              >
                                Submit
                              </Button>
                            </div>
                          </div>
                        </form>
                        {/* {successmsg && (
                            <div className="alert alert-success mt-3">
                              {successmsg}
                            </div>
                          )} */}
                      </div>
                    </div>
                  </div>
                  <div className="col-xxl-5 col-xl-5 col-lg-5 col-md-12 col-sm-12">
                    <div className="detail-part">
                      <div className="contact-pad">
                        <div className="address">
                          <h2 className="head">Head Office</h2>
                          <p>
                            <i className="location">
                              {/* <img src={LocationIcon} alt="Adress" loading="lazy" /> */}
                            </i>
                            <span>
                              <b>Orex Trade World Inc</b>
                              Milledgeville, GA, 31061-7076, USA
                            </span>
                          </p>
                          <Link className="number" to={`tel:${process.env.REACT_APP_WHATSAPP_NUMBER}`}>
                            <i className="call">
                              {/* <img src={Call} alt="Call" loading="lazy" /> */}
                            </i>
                            <span>
                              <b>Phone Number</b>
                              {process.env.REACT_APP_WHATSAPP_NUMBER}
                            </span>
                          </Link>
                          <Link className="email" to={`mailto:${process.env.REACT_APP_SUPPORT_MAIL}`}>
                            <i className="email">
                              {/* <img src={Email} alt="Call" loading="lazy" /> */}
                            </i>
                            <span>
                              <b>Email Address</b>
                              {process.env.REACT_APP_SUPPORT_MAIL}
                            </span>
                          </Link>
                        </div>
                      </div>
                      <div className="other-details">
                        <div className="other">
                          <h2 className="head">Offices</h2>
                          <span className="flag usa m-b-15" title="USA"></span>
                          <span className="flag india m-b-15" title="India"></span>
                          <span className="flag uae m-b-15" title="UAE"></span>

                        </div>
                      </div>
                      {/* <div className="other-details">
                        <div className="address">
                          <h6 className="m-b-5">Lets Call & Email</h6>
                          <Link className="number" to="tel:+1 (786) 772-5447">
                            <img src={Call} alt="Call" />
                            +1 (786) 772-5447
                          </Link>
                          <Link className="email" to="mailto:support@orextrade.com">
                            <img src={Email} alt="Call" />
                            support@orextrade.com
                          </Link>
                        </div>
                      </div> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>


        <div className="container-fluid contact-wrape">
          <div className="box-inner">
            <div className="row">
              <div className="col-lg-12">
                <div className="map-wrape">
                  <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d6680.230276388535!2d-83.292999!3d33.158604!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88f6b9134eb70973%3A0xdcbdd0b37a1438b1!2sOrex%20Trade%20World%20INC!5e0!3m2!1sen!2sin!4v1750663911259!5m2!1sen!2sin"
                    width="600" height="450" allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="orex-address"></iframe>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ToastContainer />
      </section>
      <ConsentManager data={""} />
      <WhatsappChat />
    </>
  );
}

export default Index;